/** 입력에서 숫자만 남긴다 (하이픈/공백 제거). */
export function normalizeKrPhone(input: string): string {
  return input.replace(/\D/g, '')
}

/** 국내(+82) 휴대폰 번호 형식 검증. 백엔드 정규식 ^01[016789]\d{7,8}$ 와 동일. */
export function isValidKrPhone(input: string): boolean {
  return /^01[016789]\d{7,8}$/.test(normalizeKrPhone(input))
}
